import { wpRequest } from '../utils/requests';

const $ = jQuery.noConflict();

const scrollOffset = () => $(window).height() / -3;
const scrollMs = 200;

export function setupTheDaily() {
   // assuming "show featured" checkbox is initially on
   $(document).on('click', '.toggle-featured input', function handleToggleFeatured() {
      const showFeatured = $(this)[0].checked;
      if (showFeatured) {
         $('.thedaily').addClass('show-featured');
      }
      else {
         $('.thedaily').removeClass('show-featured');
      }
   });

   // $(document).on('click', '[data-to-tag]', function handleClickTag(e) {
   //    e.preventDefault();
   //    const dest = $(this).attr('data-to-tag');
   //    const allDestinations = $(`.issue-articles-wrapper [data-tag="${dest}"]`);
   //    if (allDestinations.length) {
   //       const first = allDestinations.first();
   //       const offset = typeof scrollOffset === 'function' ? scrollOffset() : scrollOffset;
   //       const scrollDest = first.offset().top + offset;
   //       $('html, body').animate({
   //          scrollTop: scrollDest,
   //       }, scrollMs, () => {
   //          $('[data-tag]').removeClass('last-click');
   //          first.addClass('last-click');
   //       });
   //    }
   // });

   $(document).on('click', '[data-to-tag]', function handleClickTag(e) {
      e.preventDefault();
      // const dest = $(this).attr('data-to-tag');
      let allDestinations = $('.issue-articles-wrapper b');
      const myText = $(this).text().trim();

      allDestinations = allDestinations.filter(function findDest() {
         const destText = $(this).text().trim();
         return destText === myText;
      });

      if (allDestinations.length) {
         $('.highlighted').removeClass('highlighted');
         allDestinations.addClass('highlighted');
         const first = allDestinations.first();
         const offset = typeof scrollOffset === 'function' ? scrollOffset() : scrollOffset;
         const scrollDest = first.offset().top + offset;
         $('html, body').animate({
            scrollTop: scrollDest,
         }, scrollMs, () => {
            $('.last-click').removeClass('last-click');
            first.addClass('last-click');
         });
      }
   });

   if (window._theme && window._theme.loggedIn === '1') {
      // placement edit boxes
      jQuery(document).on('blur', '.edit-placement', function editBlur() {
         const $this = jQuery(this);
         const newPlacement = parseInt($this.val(), 10);
         const oldPlacement = parseInt($this.attr('data-original'), 10);
         if (newPlacement !== oldPlacement) {
            wpRequest('update_placement', {
               id: $this.attr('data-id'),
               placement: $this.val(),
            });
            $this.attr('data-original', newPlacement);
            console.log('successfully updated placement');
         }
      });
   }
}
